import { IRoomMcBimSpaceCombo } from "./designThunk";
import { IPixPolygon } from "../components/PixBimViewer/types";
import { convertMcBimItemToPixPolygons, PartialMcBimSpace } from "../utils";
import { IRoomsSummaryHashmap } from "@backend/src/schemas";
import { PartialMcBimItem } from "../McBim/McBimSlice";

export const convertRoomsAndMcBimSpacesToRoomMcBimSpaceCombo = (
  selectedRooms: string[],
  rooms: IRoomsSummaryHashmap,
  mcBimSpaces: PartialMcBimSpace[]
): IRoomMcBimSpaceCombo[] => {
  return selectedRooms.reduce((acc, roomNumber) => {
    const room = rooms[roomNumber];
    if (room?.rfpMalRom != null) {
      const mcbimSpace = mcBimSpaces.find((space) => space.name === roomNumber);
      if (mcbimSpace != null) {
        acc.push({
          roomNumber: roomNumber,
          rfpMalRom: room.rfpMalRom,
          polygon: mcbimSpace.polygon ?? [],
          ceilingCoordinate: room.ceilingCoordinate,
          ceilingDirection: room.ceilingDirection,
        });
      }
    }
    return acc;
  }, [] as IRoomMcBimSpaceCombo[]);
};

export const filterAndTransformMcBiItemsToPixPolygons = (
  mcbimItems: PartialMcBimItem[]
): IPixPolygon[] => {
  if (mcbimItems == null) {
    return [];
  }

  return (mcbimItems ?? []).reduce((acc, mcbimItem, index) => {
    if (mcbimItem.bbox == null) {
      return acc;
    }
    const converted = convertMcBimItemToPixPolygons(mcbimItem);
    if (converted !== undefined) {
      converted.id = `mcbim-item-${index}`;
      acc.push(converted);
    }
    return acc;
  }, [] as IPixPolygon[]);
};
